import { pickList } from './pick-list';

export const batchPickList = {
  ...pickList,
  id: 'batch-pick-list',
};
